export const SELECT_SUBSCRIBED_CHANNELS = 'SELECT_SUBSCRIBED_CHANNELS';
export const SELECT_SUBSCRIBED_POSTS = 'SELECT_SUBSCRIBED_POSTS';

export const TOGGLE_LIKE = 'TOGGLE_LIKE';
export const TOGGLE_BOOKMARK = 'TOGGLE_BOOKMARK';
